var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9394_83698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 2.66666C6.52663 2.66666 5.33329 3.85999 5.33329 5.33332C5.33329 6.80332 6.52663 7.99999 7.99996 7.99999C9.47329 7.99999 10.6666 6.80332 10.6666 5.33332C10.6666 3.85999 9.47329 2.66666 7.99996 2.66666ZM7.99996 9.33332C6.22329 9.33332 2.66663 10.2233 2.66663 12V13.3333H13.3333V12C13.3333 10.2233 9.77663 9.33332 7.99996 9.33332Z",
    fill: "#8B93A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9394_83698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e6d1dbfa0e4286336eb18cef7c748645.svg";
export { ForwardRef as ReactComponent };